import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';

const initialState = {
  loading: false,
  activityLogsList: []
};
const activityLogs = createSlice({
  name: 'activityLogs',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        activityLogs: action.payload?.data?.result,
        count: action.payload?.data?.count
      };
    }
  }
});

export const activityLogsActions = activityLogs.actions;

export const getActivityLogsAction = (data) => async (dispatch) => {
  dispatch(activityLogsActions.setLoading(true));
  try {
    const res = await api.post(`api/Activity/Filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(activityLogsActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(activityLogsActions.setLoading(false));
  }
};
export default activityLogs.reducer;
